const EXAMPLE = 1;

// ADMINISTRATOR USER ROLE
const ROLE_ADMIN = 1;
const ROLE_IMPLEMENTOR = 2;
const ROLE_USER = 3;

export default {
  example: EXAMPLE,
  RoleAdmin: ROLE_ADMIN,
  RoleImplementor: ROLE_IMPLEMENTOR,
  RoleUser: ROLE_USER,
};



// WEBPACK FOOTER //
// ./src/utils/constant.js